<script>
    import { _ } from 'svelte-i18n'
</script>

<svelte:head>
    <title>{$_('page.return_policy.title')} - {$_('phrase.title')}</title>

    <meta property="og:title" content={`${$_('page.return_policy.title')} - ${$_('phrase.title')}`} />
    <meta property="og:site_name" content="Siru Store" />
    <meta property="og:description" content={$_('page.return_policy.title')} />
    <meta name="description" content={$_('page.return_policy.title')} />
</svelte:head>

<article class="text-start">
    <section class="pt-5 px-3">
        <h1 class="h3 mb-4 spaced-light fs-1">{$_('page.return_policy.title')}</h1>

        <p>{$_('page.return_policy.p_1')}</p>
        <p>{$_('page.return_policy.p_2')}</p>
    </section>

    <section class="pt-3 px-3">
        <h2 class="mb-4 spaced-light fs-4">{$_('page.return_policy.section_1.h')}</h2>
        <p>{$_('page.return_policy.section_1.p_1')}</p>
    </section>

    <section class="pt-3 px-3">
        <h2 class="mb-4 spaced-light fs-4">{$_('page.return_policy.section_2.h')}</h2>
        <p>{$_('page.return_policy.section_2.p_1')}</p>
    </section>

    <section class="pt-3 px-3">
        <h2 class="mb-4 spaced-light fs-4">{$_('page.return_policy.section_3.h')}</h2>
        <p>{$_('page.return_policy.section_3.p_1')}</p>
        <p>{$_('page.return_policy.section_3.p_2')}</p>
    </section>

    <section class="pt-3 px-3">
        <p class="mt-5">{$_('page.return_policy.p_3')}</p>
    </section>
</article>
